import React from 'react';
import { useDarkMode } from 'utils/darkMode';
import { notice, colors } from './legalStyles';

/**
 * LegalNotice
 * Reusable notice component for legal pages
 * Supports different notice types (info, warning)
 */
const LegalNotice = ({ type = 'info', heading, children, className = '' }) => {
  const { isDarkMode } = useDarkMode();
  
  const noticeStyle = {
    ...notice[type],
    marginBottom: '24px',
    backgroundColor: isDarkMode 
      ? (type === 'info' ? 'rgba(96, 165, 250, 0.1)' : 'rgba(245, 158, 11, 0.1)')
      : notice[type].backgroundColor,
    borderColor: isDarkMode
      ? (type === 'info' ? '#60a5fa' : '#f59e0b')
      : notice[type].border,
    color: isDarkMode ? '#cbd5e1' : colors.text
  };

  const headingStyle = {
    ...notice.heading,
    color: isDarkMode ? '#e5e7eb' : colors.text
  };
  
  const textStyle = {
    ...notice.text,
    color: isDarkMode ? '#cbd5e1' : colors.text
  };

  return (
    <div 
      style={noticeStyle} 
      role="alert" 
      aria-live="polite"
      className={className}
    >
      {heading && (
        <div style={headingStyle}>{heading}</div>
      )}
      <div style={textStyle}>
        {children}
      </div>
    </div>
  );
};

export default LegalNotice;







